import { Center, Image } from "@chakra-ui/react";
import React from "react";

const Loading=()=>{
 
    return <Center>
        <Image src="https://digitalsynopsis.com/wp-content/uploads/2016/06/loading-animations-preloader-gifs-ui-ux-effects-28.gif"/>
    </Center>
}

export default Loading